<template>
  <v-row>
      <v-checkbox dense class="scheduleLabels codesFilter mr-2" label="Gallops" color="primary" v-model="selected" value="THOROUGHBRED" hide-details></v-checkbox>
      <v-checkbox dense class="scheduleLabels codesFilter mr-2" label="Harness" color="primary" v-model="selected" value="HARNESS"  hide-details></v-checkbox>
      <!--<v-checkbox dense class="scheduleLabels codesFilter mr-2" label="Greys" color="primary" v-model="selected"  value="GREYHOUND" hide-details></v-checkbox>-->
  </v-row>
</template>

<script>
export default {
  props: {
    codes: Array,
    onClick: Function,
  },
  computed: {
    selected: {
      get () {
        return this.codes
      },
      set (value) {
        return this.onClick(value)
      }
    }
  }
}
</script>

<style>
</style>
